import './info.css';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const ROLES = [
  'engineering',
  'product',
  'finops',
  'finance',
  'leadership',
  'procurement',
] as const;

const roleDetailsConfig: Record<
  string,
  {
    titleKey: string;
    subtitleKey: string;
    points: string[];
    lensKey: string;
  }
> = {
  engineering: {
    titleKey: 'engineering_section_title',
    subtitleKey: 'engineering_subtitle',
    points: ['engineering_point_1', 'engineering_point_2', 'engineering_point_3'],
    lensKey: 'engineering_finops_lens',
  },
  product: {
    titleKey: 'product_section_title',
    subtitleKey: 'product_subtitle',
    points: ['product_point_1', 'product_point_2', 'product_point_3'],
    lensKey: 'product_finops_lens',
  },
  finops: {
    titleKey: 'finops_section_title',
    subtitleKey: 'finops_subtitle',
    points: ['finops_point_1', 'finops_point_2', 'finops_point_3'],
    lensKey: 'finops_finops_lens',
  },
  finance: {
    titleKey: 'finance_section_title',
    subtitleKey: 'finance_subtitle',
    points: ['finance_point_1', 'finance_point_2', 'finance_point_3'],
    lensKey: 'finance_finops_lens',
  },
  leadership: {
    titleKey: 'leadership_section_title',
    subtitleKey: 'leadership_subtitle',
    points: ['leadership_point_1', 'leadership_point_2', 'leadership_point_3'],
    lensKey: 'leadership_finops_lens',
  },
  procurement: {
    titleKey: 'procurement_section_title',
    subtitleKey: 'procurement_subtitle',
    points: ['procurement_point_1', 'procurement_point_2', 'procurement_point_3'],
    lensKey: 'procurement_finops_lens',
  },
};

function InfoSection() {
  const { t } = useTranslation();
  const [activeRole, setActiveRole] = useState<string>(ROLES[0]);

  const currentRole = roleDetailsConfig[activeRole] ?? roleDetailsConfig.engineering;

  return (
    <section className="info-section section-alt" id="cloud-challenges">
      <div className="info-section-box">
        <h2 className="info-title">{t('cloud_challenges_title')}</h2>
        <p className="info-intro">{t('cloud_challenges_intro')}</p>
        <div className="info-container">
          <div className="role-row">
          {ROLES.map((role) => (
            <button
              key={role}
              type="button"
              className={`role-pill ${activeRole === role ? 'active' : ''}`}
              onClick={() => setActiveRole(role)}
            >
              {t(roleDetailsConfig[role].titleKey)}
            </button>
          ))}
        </div>
        <div className="role-detail">
          <h3 className="role-detail-title">{t(currentRole.titleKey)}</h3>
          <p className="role-detail-subtitle">{t(currentRole.subtitleKey)}</p>
          <ul className="role-detail-list">
            {currentRole.points.map((pointKey) => (
              <li key={pointKey} dangerouslySetInnerHTML={{ __html: t(pointKey) }} />
            ))}
          </ul>
          <p
            className="role-detail-lens"
            dangerouslySetInnerHTML={{ __html: t(currentRole.lensKey) }}
          />
        </div>
      </div>
      </div>
    </section>
  );
}

export default InfoSection;
